/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import { getRequestOptions, postRequestOptions } from '../helpers/Fetchwrapper'
import { Button, Table } from 'react-bootstrap-v5'
import { useParams, Link, useHistory } from 'react-router-dom'
import { KTSVG } from '../../_metronic/helpers'
import Swal from 'sweetalert2'
import GetPagePermission from '../components/GetPagePermission'

interface RouteParams {
	id: string;
}

function WorkInProgressDetails() {
	const { id }: RouteParams = useParams()
	const history = useHistory()
	const canStartQc = GetPagePermission('/wip-qc')
	const canPackingOrders = GetPagePermission('/packing-orders')
	const [order, setOrder] = useState<any>(null)
	const [rows, setRows] = useState<any[]>([])
	const [saving, setSaving] = useState(false)

	const loadOrder = () => {
		fetch(process.env.REACT_APP_API_URL + 'blending-orders/' + id, getRequestOptions())
			.then((resp) => resp.json())
			.then((resp) => {
				setOrder(resp.data)
				setRows((resp.rows || []).map((row: any) => ({
					...row,
					actualQuantity: row.actualQuantity === null || row.actualQuantity === undefined || row.actualQuantity === ''
						? (row.quantity ?? '')
						: row.actualQuantity,
				})))
			})
			.catch((error) => console.log(error, 'catch the hoop'))
	}

	useEffect(() => {
		if (id) {
			loadOrder()
		}
	}, [id])

	const handleActualChange = (index: number, value: string) => {
		setRows((prev) => {
			const updated = [...prev]
			updated[index] = { ...updated[index], actualQuantity: value }
			return updated
		})
	}

	const variance = (row: any) => {
		const actual = parseFloat(row.actualQuantity)
		const bom = parseFloat(row.quantity)
		if (isNaN(actual) || isNaN(bom)) {
			return ''
		}
		return parseFloat((actual - bom).toFixed(5))
	}

	const variancePercent = (row: any) => {
		const diff = variance(row)
		const bom = parseFloat(row.quantity)
		if (diff === '' || isNaN(bom) || bom === 0) {
			return ''
		}
		return parseFloat((((diff as number) / bom) * 100).toFixed(2))
	}

	const qcLocked = order?.status === 'QC Passed'
	const canEditActuals = !qcLocked && (order?.status === 'WIP' || order?.status === 'QC')

	const canSave = canEditActuals && rows.length > 0 && rows.every((row) =>
		row.actualQuantity !== '' && row.actualQuantity !== null && !isNaN(Number(row.actualQuantity)) && Number(row.actualQuantity) >= 0
	) && !saving

	const submitActuals = async (url: string, confirmText: string, confirmButtonText: string) => {
		if (!canSave) {
			return
		}

		const confirm = await Swal.fire({
			title: 'Are you sure?',
			text: confirmText,
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#ec008c',
			cancelButtonText: 'Cancel',
			confirmButtonText,
		})
		if (!confirm.isConfirmed) {
			return
		}

		setSaving(true)
		try {
			const response = await fetch(url, postRequestOptions({
				rows: rows.map((row) => ({
					idBlendingOrderRows: row.idBlendingOrderRows,
					actualQuantity: Number(row.actualQuantity),
				})),
			}))
			const data = await response.json()
			if (data.success) {
				Swal.fire({
					icon: 'success',
					title: 'Success',
					text: data.successMessage,
				}).then(() => loadOrder())
			} else {
				Swal.fire({
					icon: 'error',
					title: 'Error',
					text: data.errorMessage || data.errors || 'Action failed.',
				})
			}
		} catch (error) {
			Swal.fire({
				icon: 'error',
				title: 'Error',
				text: 'An error occurred.',
			})
		} finally {
			setSaving(false)
		}
	}

	const handleSave = async (event: React.FormEvent) => {
		event.preventDefault()
		await submitActuals(
			`${process.env.REACT_APP_API_URL}blending-orders/save-actual/${id}`,
			'Stock-out will be updated to the actual quantities.',
			'Yes, Save'
		)
	}

	if (!order) {
		return (
			<div className="card card-custom">
				<div className="card-body">Loading...</div>
			</div>
		)
	}

	return (
		<div className="card card-custom">
			<div className="card-header">
				<div className="card-title">
					<KTSVG path="/media/svg/icons/Text/Bullet-list.svg" className="svg-icon-1 svg-icon-primary" />
					<span className="text fw-bolder" style={{ marginLeft: '10px' }}>
						Work In Progress Details
					</span>
				</div>
				<div className="card-toolbar">
					{order.status === 'WIP' && canStartQc === 1 &&
						<button
							type="button"
							className="btn btn-sm btn-warning me-2"
							onClick={async () => {
								const confirm = await Swal.fire({
									title: 'Are you sure?',
									text: 'You want to start QC for this blending order?',
									icon: 'warning',
									showCancelButton: true,
									confirmButtonColor: '#ec008c',
									cancelButtonText: 'Cancel',
									confirmButtonText: 'Yes, Start QC',
								})
								if (!confirm.isConfirmed) {
									return
								}
								const response = await fetch(
									`${process.env.REACT_APP_API_URL}blending-orders/start-qc/${id}`,
									postRequestOptions({})
								)
								const data = await response.json()
								if (data.success) {
									Swal.fire({ icon: 'success', title: 'Success', text: data.successMessage }).then(() => loadOrder())
								} else {
									Swal.fire({ icon: 'error', title: 'Error', text: data.errorMessage || data.errors || 'Action failed.' })
								}
							}}
						>
							Start QC
						</button>
					}
					{order.status === 'QC Passed' && canPackingOrders === 1 && Number(order.remainingQty) > 0 &&
						<Link to={`/packing-order-create/${id}`} className="btn btn-sm btn-primary me-2">
							Create Packing Order
						</Link>
					}
					<Link to="/work-in-progress" className="btn btn-sm btn-secondary">Back</Link>
				</div>
			</div>
			<div className="card-body">
				<Table size="sm" bordered>
					<tbody>
						<tr>
							<td width="30%">Production Order No</td>
							<td> : {order.productionOrderNo}</td>
						</tr>
						<tr>
							<td>Status</td>
							<td> : {order.status}</td>
						</tr>
						<tr>
							<td>Project</td>
							<td> : {order.projectName}</td>
						</tr>
						<tr>
							<td>Production Date</td>
							<td> : {order.productionDate}</td>
						</tr>
						<tr>
							<td>Product Name</td>
							<td> : {order.itemName}</td>
						</tr>
						<tr>
							<td>Product Code</td>
							<td> : {order.itemCode}</td>
						</tr>
						<tr>
							<td>BOM</td>
							<td> : {order.bomName}</td>
						</tr>
						<tr>
							<td>Production Quantity</td>
							<td> : {order.productionQuantity} {order.unitName}</td>
						</tr>
						<tr>
							<td>Already Used</td>
							<td> : {order.alreadyUsed}</td>
						</tr>
						<tr>
							<td>Remaining Quantity</td>
							<td> : {order.remainingQty}</td>
						</tr>
						<tr>
							<td>Weight in KG</td>
							<td> : {order.weightInKg}</td>
						</tr>
						<tr>
							<td>Batch No</td>
							<td> : {order.batchNo}</td>
						</tr>
						<tr>
							<td>Created By</td>
							<td> : {order.createdBy}</td>
						</tr>
					</tbody>
				</Table>

				<form onSubmit={handleSave}>
					<h5 className="mt-5 mb-3">Required Materials</h5>
					<Table size="sm" bordered hover>
						<thead>
							<tr>
								<th>SN</th>
								<th>Item Name</th>
								<th>Category</th>
								<th>Percentage</th>
								<th>Quantity</th>
								<th>Unit</th>
								<th>Warehouse</th>
								<th>Actual Qty</th>
								<th>Variance</th>
								<th>Variance %</th>
							</tr>
						</thead>
						<tbody>
							{rows.map((row, index) => (
								<tr key={row.idBlendingOrderRows || index}>
									<td>{index + 1}</td>
									<td>{row.itemName}</td>
									<td>{row.categoryName}</td>
									<td>{row.percentage}</td>
									<td>{row.quantity}</td>
									<td>{row.unitName}</td>
									<td>{row.warehouseName}</td>
									<td style={{ minWidth: '120px' }}>
										{qcLocked
											? row.actualQuantity
											: (
												<input
													type="number"
													className="form-control form-control-sm"
													step="0.00001"
													min="0"
													value={row.actualQuantity}
													onChange={(event) => handleActualChange(index, event.target.value)}
												/>
											)
										}
									</td>
									<td>{variance(row)}</td>
									<td>{variancePercent(row) === '' ? '' : variancePercent(row) + '%'}</td>
								</tr>
							))}
						</tbody>
					</Table>

					{canEditActuals &&
						<div className="form-group row mt-4">
							<div className="col text-center">
								<button type="submit" className="btn btn-sm btn-primary me-2" disabled={!canSave}>
									Save
								</button>
								{canStartQc === 1 &&
									<button
										type="button"
										className="btn btn-sm btn-success me-2"
										disabled={!canSave}
										onClick={() => submitActuals(
											`${process.env.REACT_APP_API_URL}blending-orders/pass-qc/${id}`,
											'Actual quantities will be saved and QC will be passed. No further QC can be done.',
											'Yes, Pass QC'
										)}
									>
										Pass QC
									</button>
								}
								<Button variant="secondary" size="sm" onClick={() => history.push('/work-in-progress')}>
									Close
								</Button>
							</div>
						</div>
					}
				</form>
			</div>
		</div>
	)
}

export default WorkInProgressDetails
